module.exports = __webpack_public_path__ + "static/img/6-36.fce4937.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/6-36.png
// module id = EkUA
// module chunks = 15